import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BaseUrl } from "../../../helper/BaseUrl";

const formatDate = (date) => {
  if (!date) return "";
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(date));
};

export default function MediaGrid({ data }) {
  const [visibleCount, setVisibleCount] = useState(9);

  useEffect(() => {
    setVisibleCount(9);
  }, [data]);

  const handleLoadMore = () => {
    if (visibleCount >= data.length) {
      setVisibleCount(9);
      return;
    }
    setVisibleCount((current) => Math.min(current + 9, data.length));
  };

  const visibleData = data.slice(0, visibleCount);

  return (
    <section className="mediagrid-area">
      <div className="container">
        <div className="row">
        {visibleData.map((item) => (
            <div className="col-lg-4 col-md-6" key={item._id}>
              <div className="media-card">
                <Link to={`/media/${item.slug}`}>
                <img src={item.thumbnail_image ? BaseUrl + item.thumbnail_image : ""} className="img-responsive"   alt={item.title} />
                <span>{item?.title?.slice(0, 100)}</span>
                <p>{item.short_description}</p>
                <div className="media-card-footer">
                  <small>{formatDate(item.date)}</small>
                  <div className="media-arrow">
                    <i className="fa-solid fa-arrow-right"></i>
                  </div>
                </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
        {data.length > 9 && (
          <div className="load-more text-center mt-4">
            <button    className="theme-btn"    onClick={handleLoadMore}  >
              <span>   {visibleCount >= data.length ? "Load Less" : "Load more"} </span> </button>
          </div>
        )}

      </div>
    </section>

  )

}
